import { Phone } from "lucide-react";
import { Reveal } from "./motion";
import { Btn } from "./Buttons";
import { PHONE, PHONE_HREF } from "../../data/site";

export const CtaBand = ({ title = "Ogni richiesta merita attenzione, competenza e una risposta organizzata.", to = "/contatti#modulo", cta = "Richiedi un servizio" }) => (
  <section data-testid="cta-band" className="bg-white py-16 md:py-24">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="relative overflow-hidden rounded-[28px] bg-navy px-6 py-14 text-white md:px-16 md:py-20">
        <div className="pointer-events-none absolute -right-20 -top-20 h-80 w-80 rounded-full border border-gold/30" />
        <div className="pointer-events-none absolute -right-4 top-10 h-48 w-48 rounded-full border border-white/10" />
        <div className="relative grid gap-10 lg:grid-cols-[1.4fr_1fr] lg:items-end">
          <h2 className="text-2xl font-semibold leading-snug md:text-4xl">{title}</h2>
          <div className="flex flex-col gap-4 sm:flex-row lg:flex-col lg:items-start">
            <Btn to={to} variant="gold" testId="cta-band-request-btn">{cta}</Btn>
            <a href={PHONE_HREF} data-testid="cta-band-phone-link" className="inline-flex items-center gap-3 text-white/90 transition-colors hover:text-gold">
              <Phone className="h-4 w-4 text-gold" strokeWidth={1.5} />
              <span className="text-sm">Centrale Operativa <strong className="ml-1 text-base text-white">{PHONE}</strong></span>
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
